module.exports = __webpack_public_path__ + "static/img/travel.d9639986.svg";